module.exports = __webpack_public_path__ + "static/media/training-reg.e7bd49c7.png";